// libraries
import React from 'react'
import clsx from 'clsx'

// prop types
export interface SectionProps {
    children?: React.ReactNode
    bgColor?: 'bg-primary' | 'bg-beige-050' | 'bg-blue-primary-500' | 'bg-blue-primary-light' | 'bg-beige-primary-dark' | 'bg-beige-primary-light' | 'bg-green-secondary-dark' | 'bg-green-secondary-light' | 'bg-green-insights' | 'bg-green-500' | 'bg-orange' | 'bg-white' | string
    textColor?: 'text-light' | 'text-dark' | 'text-secondary' | 'text-white'
    className?: string
    id?: string
    articleType?: 'news' | 'insights'
}


export default function Section({
    bgColor,
    textColor,
    children,
    className,
    id,
    articleType
}: SectionProps) {

    // custom bg color
    const customBgColor = bgColor && ![].includes(bgColor) ? { backgroundColor: bgColor } : {}

    return (
        <section
            id={id}
            className={clsx(
                'section',
                
                // bg colors
                bgColor === 'bg-primary' && 'bg-primary',
                bgColor === 'bg-blue-primary-500' && 'bg-blue-primary-500',
                bgColor === 'bg-blue-primary-light' && 'bg-blue-primary-light',
                bgColor === 'bg-beige-primary-dark' && 'bg-beige-primary-dark',
                bgColor === 'bg-beige-primary-light' && 'bg-beige-primary-light',
                bgColor === 'bg-green-secondary-dark' && 'bg-green-secondary-dark',
                bgColor === 'bg-green-secondary-light' && 'bg-green-secondary-light',
                bgColor === 'bg-green-insights' && 'bg-green-insights',
                bgColor === 'bg-green-500' && 'bg-green-500',
                bgColor === 'bg-orange' && 'bg-orange',
                bgColor === 'bg-white' && 'bg-white',
                bgColor === 'bg-beige-050' && 'bg-beige-050',

                // text colors
                textColor === 'text-light' && 'text-light',
                textColor === 'text-dark' && 'text-dark',
                textColor === 'text-white' && 'text-white',
                textColor === 'text-secondary' && 'secondary',

                // article type
                articleType === 'news' && 'bg-beige-primary-light',
                articleType === 'insights' && 'bg-green-insights',

                className
            )}
        >

            <div className='relative'>
                {children}
            </div>

        </section>
    )
}